import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import InputBox from '@/components/profile/inputBox'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/basicDetails/constants"

import '@/pages/profile/sections/common.css'
import { userWebsitePaths } from '@/constants/userWebsitePaths';

export default function DisplayName(props: any) {
    const { common, profile } = useLocalTranslation();
    const termsOfServicePath = process.env.REACT_APP_USER_PANEL_URL + userWebsitePaths.termsOfService

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <p className='commonH2'>
                {profile.fields.displayName}
                <span className='text-[#FF2828]'>*</span>
            </p>
            <div className='commonCon1'>
                <p>
                    {profile.basicDetailsSection.notes.n1}{' '}
                    <a
                        className='commonAnchor1'
                        href={termsOfServicePath}
                        target="_blank"
                        rel="noopener noreferrer">
                        {common.statusText.termsOfService}
                    </a>
                </p>
                <p>{profile.basicDetailsSection.notes.n2}</p>
            </div>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }
            <InputBox
                id={listOfSections.displayName}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.displayName)}
                value={props.value}
                placeholder={profile.placeHolders.enterYourName}
                showAsterisk={true}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.displayName)}
                />
            </div>
        </div>
    );
}
